var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import HomePage from "@/views/home";
import { routesGame } from "./routes/routesGame";
import { routesManage } from "./routes/routesManage";
import { routesPlace } from "./routes/routesPlace";
import { routesProfile } from "./routes/routesProfile";
import { routesUsers } from "./routes/routesUsers";
import { RoutesList } from "./routesList";
export var routes = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
    {
        path: RoutesList.Root,
        element: _jsx(HomePage, {}),
    }
], routesPlace, true), routesProfile, true), routesGame, true), routesUsers, true), routesManage, true);
